module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container",
    attrs: {
      "id": "mobileViewPort"
    }
  }, [_c('div', {
    attrs: {
      "id": "mobileMode_person"
    }
  }, [(_vm.personForm.isSport == '0') ? _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-top": "10px"
    },
    attrs: {
      "id": "queryArea_person"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "默认全部选修课类型",
      "clearable": ""
    },
    on: {
      "change": _vm.changeCourseType
    },
    model: {
      value: (_vm.personForm.courseType),
      callback: function($$v) {
        _vm.$set(_vm.personForm, "courseType", $$v)
      },
      expression: "personForm.courseType"
    }
  }, _vm._l((_vm.courseTypeInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "listArea_person"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.personalInfoData == null || _vm.personalInfoData.length == 0) ? _c('div', {
    staticClass: "cardTips"
  }, [_vm._v("没有选课记录")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.personalInfoData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cardMain"
    }, [_c('div', {
      staticClass: "cardText"
    }, [_c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("学年学期：")]), _vm._v(_vm._s(item.xnxqmc))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("选修班名称：")]), _vm._v(_vm._s(item.electiveClassName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("学分：")]), _vm._v(_vm._s(item.credit))])]), _vm._v(" "), _c('div', {
      staticClass: "cardInput"
    }, [(item.curXnxq == item.xnxqbm && item.selectCourse == '1') ? _c('el-button', {
      attrs: {
        "size": "small",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.delSelection(item);
        }
      }
    }, [_vm._v("\n                        删除\n                    ")]) : _vm._e()], 1)])
  }), _vm._v(" "), (_vm.total > 2 && _vm.total > _vm.personalInfoData.length) ? _c('div', {
    attrs: {
      "id": "loadingTips"
    }
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" 信息加载中，请稍候...\n            ")]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-145a9d58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/personInfo.vue
// module id = 1781
// module chunks = 502